import { showToast } from "../../../utils/styles/toastUtils";
import { postSignUpApi } from "../../apis/auth/postSignUpApi";
import * as types from "../ActionTypes";
import { SendOtpActionInitiate } from "./sendOtpAction";

export const SignUpActionStart = () => ({
  type: types.POST_SIGNUP_START,
});

export const SignUpActionSuccess = (data) => ({
  type: types.POST_SIGNUP_SUCCESS,
  payload: data,
});

export const SignUpActionError = (error) => ({
  type: types.POST_SIGNUP_ERROR,
  payload: error,
});

export const SignUpActioninitiate = (data) => {
  return async function (dispatch) {
    dispatch(SignUpActionStart());

    try {
      const res = await postSignUpApi(data);

      dispatch(SignUpActionSuccess(res.data));


      if (res.data?.user) {

        localStorage.setItem("auth_phone", data.phone_number);
        if (res.data.user.account_type) {
          localStorage.setItem("userType", res.data.user.account_type);
          localStorage.setItem("userId", res.data.user.id);
          sessionStorage.removeItem("onboardingFormData");
        }

        // Show backend success message if available
        if (res.data?.message) {
          showToast.success(res.data.message);
        }

        return { success: true };
      }

      // Show backend error message if available
      if (res.data?.message) {
        showToast.error(res.data.message);
      }
      return { success: false };

    } catch (error) {
      // Show only backend error message
      const errorMessage = error.response?.data?.error || error.response?.data?.message;
      if (errorMessage) {
        showToast.error(errorMessage);
      }
      console.error("SignUpActionError", error.response?.data);
      dispatch(SignUpActionError(error.response?.data?.error));

      return { success: false, error };
    }
  };
};
